import script from "./header.vue?vue&type=script&setup=true&lang=js"
export * from "./header.vue?vue&type=script&setup=true&lang=js"

import "./header.vue?vue&type=style&index=0&id=ec0a9772&lang=css"
import "./header.vue?vue&type=style&index=1&id=ec0a9772&lang=scss&scoped=true"
import "./header.vue?vue&type=style&index=2&id=ec0a9772&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec0a9772"]])

export default __exports__